import { Chat, LocalStorage } from '@/config'
import { APIClient, ConnectID } from '@/services'
import { appStatusStore } from '@/stores'
import { queryClient } from '../queryClient'

export const useLogout = () => {
  const logout = () => {
    return new Promise<void>(async (resolve) => {
      try {
        console.log('Logging out...')
        appStatusStore.setLoggingOut(true)

        LocalStorage.clear()
        queryClient.client.clear()
        await ConnectID.ConnectIDAuth.instance.logout()
        await Chat.disconnect()
        await APIClient.Session.unloadTheme()

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      } catch (e) {
        console.log('Logout error', e)
        appStatusStore.setLoggingOut(false)
      }
    })
  }

  return { logout }
}
